import { render } from "./InstanceCreationScreen.vue?vue&type=template&id=e9580028&scoped=true"
import script from "./InstanceCreationScreen.vue?vue&type=script&lang=js"
export * from "./InstanceCreationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=e9580028&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9580028"]])

export default __exports__